(function($, Drupal) {
  Drupal.behaviors.linksAsButtons = {
    attach(context) {
      once(
        "linksAsButtons",
        ".paragraph--type--blog-posts .view-content .views-row .blog-post--teaser ul.links a",
        context
      ).forEach(link => {
        link.classList.add("btn", "btn-info");
      });
    }
  };
})(jQuery, Drupal);
